module.exports = __webpack_public_path__ + "static/img/home-center.a12a17cb.jpg";